import algebra from 'algebra.js'
import * as mathUtil from '@/common/js/mathutil.js'

export default {
  title: 'Solve multi-step equations with variables on both sides',
  operation: 'solve-simple-input',
  config: { nProblems: 10, maxPlaces: 5 },
  problem: function () {
    // px + b = qx + c
    do {
      var x = mathUtil.randomIntUniform(-10, 10)
      var p = mathUtil.randomIntUniform(1, 9) * mathUtil.randomSign()
      var q = mathUtil.randomIntUniform(1, 9) * mathUtil.randomSign()
      var b = mathUtil.randomIntUniform(1, 9) * mathUtil.randomSign()
      var c = (p - q) * x + b
    } while (p === q || Math.abs(c) >= 50)

    // equation
    var px = new algebra.Expression('x').multiply(p)
    var qx = new algebra.Expression('x').multiply(q)
    var equation = new algebra.Equation(px.add(b), qx.add(c))

    // question
    var question = []
    question.push({ type: 'string', value: 'Solve for <var>x</var>.' })
    question.push({ type: 'formula', value: '$' + equation.toTex() + '$' })

    // answers
    var answers = []
    answers.push({ before: '$x = $', value: x })

    // explanation
    var steps = []
    if (q !== 0) {
      if (Math.abs(q) === 1) steps.push((q > 0) ? 'Subtract $x$ from both sides.' : 'Add $x$ to both sides.')
      else steps.push((q > 0) ? 'Subtract ' + q + '$x$ from both sides.' : 'Add ' + (-q) + '$x$ to both sides.')
      steps.push('$' + px.subtract(qx).add(b) + ' = ' + c + '$')
    }
    if (b !== 0) {
      steps.push((b > 0) ? 'Subtract ' + b + ' from both sides.' : 'Add ' + (-b) + ' to both sides.')
      steps.push('$' + px.subtract(qx) + ' = ' + (c - b) + '$')
    }
    if (p - q !== 1) {
      steps.push('Divide both sides by ' + (p - q) + '.')
      steps.push('$x = ' + x + '$')
    }

    return { question: question, answers: answers, explanation: steps }
  }
}



// WEBPACK FOOTER //
// ./src/math/drills/lin/lineqgf.js